// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: "Pandora",
  appVersion: "1.0",
  baseUrl: "https://roboze-pandora.com:443/",//"http://localhost:4200/", //"https://localhost", //https for docker, http for visualstudio
  notificationService: {
    cookieKey: "none",
    baseUrl: "https://workingnotifications.roboze.com/api_v1/"
  },
  farmer: true,
  privacyPolicy: {
    url: "https://roboze.com/privacy-policy/"
  },
  redirectTo: {
    cookieKey: "redirectTo",
    url: "https://workingid.roboze.com/auth/login",
    domain: ".roboze.com"
  },
  inCloud: {
    baseUrl: "https://roboze-pandora.com:7088/" //"https://localhost:7088/"//"http://localhost:5280/"//"http://192.168.0.220:5280/"//
  },
  support: {
    downloadUrl: "https://support.roboze.com/downloads/"
  },
  payments: {
    baseUrl: "http://payments.staging.roboze.com/api_v1/",
    redirectCookieKey: "back_url",
    domain: ".roboze.com"
  },
  streamServer: {
    url: "https://stream.roboze.com/hls/",
    streamTimeout: 900
  },
  googleDriveAuth: {
    clientId: "276073670923-l3o3eguh6puhpakm8l655p7086bdcdib.apps.googleusercontent.com",
    scope: "https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file",
    secureRoutes: ["http://localhost:5280/api/googleDrive"]
  },
  roboze:{
    url:"https://www.roboze.com"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.



